import React, {useCallback} from 'react';
import cx from 'classnames';
import {Text} from '@priority-software/priority-style-react';
import {ReactComponent as FalseIcon} from './icons/no-icon.svg';
import {ReactComponent as TrueIcon} from './icons/yes-icon.svg';
import {optionsValue} from './constants';
import texts from '../../texts';
import styles from './styles.module.scss';

type Props = {
    onChange: (val: number) => void;
    name: string;
    value: number;
    componentCLasses?: string;
};

export const BooleanButtons = (props: Props) => {
    const {onChange, value: checkedValue, componentCLasses} = props;

    const onClick = useCallback(
        e => {
            const dataVal = Number(e.currentTarget.getAttribute('data-value'));
            const actionValue = dataVal !== checkedValue ? dataVal : optionsValue.skip;

            onChange(actionValue);
        },
        [onChange, checkedValue]
    );

    return (
        <div className={cx(styles.component, componentCLasses)}>
            <label
                onClick={onClick}
                data-value={optionsValue.accept}
                className={cx(styles.btn, styles.accept, {
                    [styles.selected]: checkedValue === optionsValue.accept
                })}
            >
                <Text skin="paragraph-2" tag="span" textColor="primary-700">
                    {texts.yes_label}
                </Text>

                <TrueIcon className={styles.icon} />
            </label>

            <label
                onClick={onClick}
                data-value={optionsValue.decline}
                className={cx(styles.btn, styles.decline, {
                    [styles.selected]: checkedValue === optionsValue.decline
                })}
            >
                <Text skin="paragraph-2" tag="span" textColor="primary-700">
                    {texts.no_label}
                </Text>

                <FalseIcon className={styles.icon} />
            </label>
        </div>
    );
};
